<template>
  <LoaderCar v-if="loading" width="300px" marginTop="0" />
  <div class="piece-justif" :class="pieceClass" v-else>
    <Toast />
    <div class="header-piece">
      <div class="icon-container" :class="iconClass">
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
          <rect
            x="5"
            y="2"
            width="14"
            height="20"
            rx="2"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <path
            d="M9 7h6M9 11h4"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <circle cx="16" cy="16" r="1" fill="currentColor" />
        </svg>
      </div>
      <div class="status-piece">
        <div class="valid-piece valid-piece-header" v-if="(this.status == 'refus' || this.status == 'incomplet') && this.$store.state.user.role.label == 'secretaire'" @click="valider">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
            <!-- Cercle bleu -->
            <circle cx="50" cy="50" r="50" fill="#3B82F6" />

            <!-- Coche blanche -->
            <path
              d="M28 52 L44 68 L72 36"
              fill="none"
              stroke="white"
              stroke-width="12"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <span class="badge" :class="badgeClass" v-if="this.$store.state.user.role.label == 'secretaire' && statusBadge === 'En cours de traitement'"><span class="badge-dot"></span>À traiter</span>
        <span class="badge" :class="badgeClass" v-else><span class="badge-dot"></span>{{ statusBadge }}</span>
      </div>
    </div>

    <div class="info-piece">
      <p class="title">{{ pieceSelected.typePieceJustificative.label }}</p>
      <p class="desc">{{ pieceSelected.typePieceJustificative.description }}</p>
    </div>

    <div class="refus" v-if="this.status == 'refus'">
      <template v-if="this.$store.state.user.role.label == 'eleve'">
        <p class="title-status">Refus de votre pièce :</p>
        <p class="last">{{pieceSelected.commentaire}}</p>
      </template>
      <template v-else>
        <p class="title-status-refus">Pièce refusé :</p>
        <p></p>
        <textarea
          name="commentaire"
          id="commentaire"
          v-model="pieceSelected.commentaire"
        ></textarea>
        <button
          class="send-refus"
          @click="confirmerCommentaire()"
          :disabled="saveCommentaireClick"
        >
          <span v-if="pieceSelected.commentaire == ''">ENVOYER</span
          ><span v-else>MODIFIER</span>
        </button>
      </template>

    </div>

    <div class="status-content" v-if="this.status == 'incomplet'">
      <div class="add" v-if="this.$store.state.user.role.label == 'eleve'">
        <label
          >+<input
            type="file"
            name="test"
            ref="fileInput"
            @change="addFile()"
            multiple
        /></label>
      </div>
    </div>

    <div
      class="status-content"
      v-if="
        this.status == 'incompletbis' &&
        this.$store.state.user.role.label == 'eleve'
      "
    >
      <div class="header-status">
        <p class="title-status">Envoi de pièce</p>
        <div class="littleadd">
          <label
            >+<input
              type="file"
              name="test"
              ref="fileInput"
              @change="addFile()"
              multiple
          /></label>
        </div>
      </div>
      <div class="send-content">
        <template v-for="fichier in fileList" :key="fichier">
          <p>
            <a
              :href="fichier.file_data"
              :download="fichier.file_name"
              target="_blank"
              >{{ fichier.file_name }}</a
            >
            <a @click="delFile(fichier)">x</a>
          </p>
        </template>
        <p class="file-error" v-if="fileError">{{ fileError }}</p>
        <button @click="savePiece()" v-if="!savePieceClick">ENVOYER</button>
        <button @click="savePiece()" v-else disabled>ENVOYER</button>
      </div>
    </div>

    <div class="status-content" v-if="this.status == 'refus'">
      <template v-if="this.$store.state.user.role.label == 'eleve'">
        <div class="header-status">
          <p class="title-status">Envoi de pièce</p>
          <div class="littleadd">
            <label
              >+<input
                type="file"
                name="test"
                ref="fileInput"
                @change="addFile()"
                multiple
            /></label>
          </div>
        </div>
        <div class="send-content" v-if="fileList.length !== 0">
          <template v-for="fichier in fileList" :key="fichier">
            <p>
              <a
                :href="fichier.file_data"
                :download="fichier.file_name"
                target="_blank"
                >{{ fichier.file_name }}</a
              >
              <a @click="delFile(fichier)">x</a>
            </p>
          </template>
          <button @click="savePiece()" v-if="!savePieceClick">ENVOYER</button>
          <button @click="savePiece()" v-else disabled>ENVOYER</button>
        </div>
      </template>
    </div>

    <div class="status-content" v-if="this.status == 'wait'">
      <div class="header-status">
        <p class="title-status">En cours de traitement</p>
        <p class="sub-title-status" v-if="pieceSelected.fichier.length !== 0">
          Envoyé le
          {{
            pieceSelected.fichier[pieceSelected.fichier.length - 1].date.slice(
              0,
              10,
            )
          }}
        </p>
      </div>
      <div class="send-content">
        <template v-if="pieceSelected.fichier.length !== 0">
          <template
            v-for="fichier in pieceSelected.fichier[
              pieceSelected.fichier.length - 1
            ].fichier"
            :key="fichier"
          >
            <p>
              <a
                :href="fichier.file_data"
                :download="fichier.file_name"
                target="_blank"
                >{{ fichier.file_name }}</a
              >
            </p>
          </template>
        </template>

        <div
          class="actions-wait"
          v-if="this.$store.state.user.role.label == 'secretaire'"
        >
          <button @click="traiter(true)">ACCEPTER</button>
          <button @click="traiter(false)">REFUSER</button>
        </div>
      </div>
    </div>

    <div class="status-content" v-if="this.status == 'good'">
      <div class="header-status">
        <p class="title-status">Pièce acceptée, sous réserve de validation par la préfecture</p>
      </div>
      <div class="send-content">
        <div class="good-status">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
            <!-- Cercle vert -->
            <circle cx="50" cy="50" r="50" fill="#00B300" />

            <!-- Coche blanche -->
            <path
              d="M28 52 L44 68 L72 36"
              fill="none"
              stroke="white"
              stroke-width="12"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div
        v-if="$store.state.user.role.label == 'secretaire'"
        class="refuse-accepted-row"
      >
        <button class="btn-refuse-accepted" @click="refuserPieceAcceptee">
          Annuler l'acceptation
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import LoaderCar from "../../LoaderCar.vue";
import { useToast } from "primevue/usetoast";

export default {
  components: {
    LoaderCar,
  },

  props: ["piece", "student"],

  data() {
    return {
      status: null,
      statusBadge: null,
      pieceSelected: null,
      loading: true,
      fileList: null,
      savePieceClick: false,
      saveCommentaireClick: false,
      fileError: null,
      toast: useToast(),
    };
  },

  mounted() {
    this.selectPiece();
  },

  methods: {

    valider() {
      // Indique qu'un envoi est en cours de traitement
      this.isWorkingValider = true;
      // Met à jour la pièce
      window.api
        .patch(
          "/piece_justificatives/" + this.pieceSelected.id,
          {
            etat: true,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          }
        )
        .then(() => {
          this.setStatusDossier();
          // Modifie l'état sur les données local
          this.pieceSelected.etat = true;
          // Met à jour la liste des éléves
          this.selectPiece();
          // Indique qu'un envoi n'est plus en cours de traitement
        })
        .catch((error) => {
          // Indique qu'un envoi n'est plus en cours de traitement
          console.log(error);
        });
    },

    refuserPieceAcceptee() {
      window.api
        .patch(
          "/piece_justificatives/" + this.pieceSelected.id,
          { etat: false },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          }
        )
        .then(() => {
          const idx = this.$store.state.dossier.pieceJustificatives.findIndex(
            (el) => el.id === this.pieceSelected.id
          );
          if (idx !== -1) {
            this.$store.state.dossier.pieceJustificatives[idx].etat = false;
          }
          this.pieceSelected.etat = false;

          if (this.pieceSelected.fichier && this.pieceSelected.fichier.length > 0) {
            this.traiter(false);
          } else {
            this.unsetSaisiIfNeeded();
            window.api
              .post(
                "/sendMail",
                {
                  type: "dossier refus",
                  piece: this.pieceSelected.typePieceJustificative.label,
                  email: this.student.email,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                },
              )
              .catch((error) => {
                console.log(error);
              });
            this.selectPiece();
            this.setStatusDossier();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    traiter(etat) {
      let tmpPieceSelectedFichier = this.pieceSelected.fichier;
      tmpPieceSelectedFichier[this.pieceSelected.fichier.length - 1].etat =
        etat;
      // Ouvre le modal de validation si l'envoi est accépté
      this.modalSelected = etat;
      // Mise à jour de la pièce
      window.api
        .post(
          "/piece_justificatives/" + this.pieceSelected.id + "/traiter",
          {
            etat: etat,
            commentaire: this.pieceSelected.commentaire,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/json",
            },
          },
        )
        .then(() => {
          this.setStatusDossier();
          this.selectPiece();
          if(etat === true){
            this.valider()
          }
          // Indique que la pièce n'est plus à traiter
          this.pieceSelected.aTraiter--;
          // Modifi les données local
          this.pieceSelected.fichier = tmpPieceSelectedFichier;
          // Si l'envoi est accépté
          
          if (etat === false) {
            this.unsetSaisiIfNeeded();
            // Envoi un mail
            console.log("oui l : ", etat);
            window.api
              .post(
                "/sendMail",
                {
                  type: "dossier refus",
                  piece: this.pieceSelected.typePieceJustificative.label,
                  email: this.student.email,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                },
              )
              .then(() => {
                  this.majElevesDossier();
              })
              .catch((error) => {
                console.log(error);
              });
          }else{
            this.majElevesDossier();
          }
          // Met à jour la liste des éléves
          
        })
        .catch((error) => {
          console.log(error);
        });
    },

    unsetSaisiIfNeeded() {
      // Désaisit le dossier sur ANTS si une pièce est refusée/annulée alors que le dossier était déjà saisi
      if (this.student.dossier.ants !== true) return;
      window.api
        .patch(
          "/dossiers/" + this.student.dossier.id,
          {
            ants: false,
            status: "Saisi",
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          },
        )
        .then(() => {
          this.$emit("unsetSaisi");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    confirmerCommentaire() {
      // Indique qu'un commentaire est en cours de d'enregistrement
      this.saveCommentaireClick = true;
      // Enregistre le commentaire
      window.api
        .patch(
          "/piece_justificatives/" + this.pieceSelected.id,
          {
            commentaire: this.pieceSelected.commentaire,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          },
        )
        .then(() => {
          this.toast.add({
            severity: "success",
            summary: "Félicitaion",
            detail: "Commentaire envoyé à l'élève !",
            life: 5000,
          });
          this.setStatusDossier();
          this.saveCommentaireClick = false;
          this.selectPiece();
        })
        .catch((error) => {
          // Indique qu'un commentaire n'est plus en cours de d'enregistrement
          this.saveCommentaireClick = false;
          console.log(error);
        });
    },

    setStatusDossier() {
      let userId = null;

      if (this.student === null) {
        userId = this.$store.state.user.id;
      } else {
        userId = this.student.id;
      }

      window.api
        .post(
          "/update/uneleve/dossier/" + userId,
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          },
        )
        .then(() => {})
        .catch((error) => {
          console.log(error);
        });
    },

    savePiece() {
      if (!this.savePieceClick) {
        this.savePieceClick = true;
        //let tmpPieceSelectedFichier = this.pieceSelected.fichier;


          const formData = new FormData();
          formData.append("commentaire", this.pieceSelected.commentaire || "");

          // Convertit chaque base64 en Blob et l'ajoute au FormData
          for (let i = 0; i < this.fileList.length; i++) {
            const item = this.fileList[i];
            const blob = this.base64ToBlob(item.file_data);
            formData.append(`fichiers[${i}]`, blob, item.file_name);
          }

          window.api.post(
            "/piece_justificatives/" + this.pieceSelected.id + "/upload",
            formData,
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
                "Content-Type": "multipart/form-data",
              },
            }
          ).then(() => {
            
            //this.pieceSelected.fichier = tmpPieceSelectedFichier;
            this.savePieceClick = false;
            this.setStatusDossier();
            this.selectPiece();
            //window.location.reload();
            
          })
          .catch((error) => {
            this.savePieceClick = false;
            console.log(error);
          });

      }
    },

    // Ajoute cette méthode utilitaire dans methods
    base64ToBlob(dataURL) {
      const [meta, data] = dataURL.split(",");
      const mime = meta.match(/:(.*?);/)[1];
      const binary = atob(data);
      const array = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        array[i] = binary.charCodeAt(i);
      }
      return new Blob([array], { type: mime });
    },

    compressFile(file) {
      return new Promise((resolve) => {
        const MAX_SIZE_BYTES = 4 * 1024 * 1024; // 4 Mo max après compression

        // Si ce n'est pas une image, on encode directement sans compresser
        if (!file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onloadend = () => {
            if (reader.result.length > MAX_SIZE_BYTES * 1.37) {
              resolve({ error: true, name: file.name });
            } else {
              resolve({ file_name: file.name, file_data: reader.result });
            }
          };
          reader.readAsDataURL(file);
          return;
        }

        // Pour les images : compression via Canvas
        const reader = new FileReader();
        reader.onloadend = () => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            let width = img.width;
            let height = img.height;

            // Redimensionne si trop grande (max 1920px)
            const MAX_DIM = 1920;
            if (width > MAX_DIM || height > MAX_DIM) {
              if (width > height) {
                height = Math.round((height * MAX_DIM) / width);
                width = MAX_DIM;
              } else {
                width = Math.round((width * MAX_DIM) / height);
                height = MAX_DIM;
              }
            }

            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            // Compression JPEG à 80%
            const compressed = canvas.toDataURL("image/jpeg", 0.8);

            if (compressed.length > MAX_SIZE_BYTES * 1.37) {
              resolve({ error: true, name: file.name });
            } else {
              resolve({ file_name: file.name, file_data: compressed });
            }
          };
          img.src = reader.result;
        };
        reader.readAsDataURL(file);
      });
    },

    async addFile() {
      this.fileError = null;
      let input = this.$refs.fileInput;
      for (let i = 0; i < input.files.length; i++) {
        const result = await this.compressFile(input.files[i]);
        if (result.error) {
          this.fileError = `Le fichier "${result.name}" est trop volumineux (max 4 Mo).`;
        } else {
          this.fileList.push(result);
        }
      }
      if (this.status !== "refus") {
        this.status = "incompletbis";
      }
    },

    selectPiece() {
      this.loading = true;
      if (!this.piece.etat) {
        if (!this.savePieceClick) {
          this.fileList = [];
          // Force le rechargement depuis l'API à chaque fois
          window.api
            .get("/piece_justificatives/" + this.piece.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then((response) => {
              // La réponse de l'API fait foi pour les champs frais (fichier, etat...),
              // mais ne renvoie pas forcément le "typePieceJustificative" imbriqué :
              // on le garde depuis la prop, toujours complète.
              this.pieceSelected = {
                ...response.data,
                typePieceJustificative: this.piece.typePieceJustificative,
              };

              // Best-effort : resynchronise le tableau du store s'il contient encore cette pièce
              let idPieceSelected =
                this.$store.state.dossier.pieceJustificatives.findIndex(
                  (el) => el.id === response.data.id,
                );
              if (idPieceSelected !== -1) {
                this.$store.state.dossier.pieceJustificatives[
                  idPieceSelected
                ].fichier = response.data.fichier;
              }

              this.pieceOnload = false;
              this.loading = false;
              this.calculStatus();
            })
            .catch((error) => {
              console.log(error);
            });
        }else{
          this.loading = false;
        }
      } else {
        this.pieceSelected = this.piece;
        this.loading = false;
        this.calculStatus();
      }
    },

    delFile(item) {
      // Retire de la fileList le fichier en paramètre
      this.fileList = this.fileList.filter((el) => el !== item);

      if (this.fileList.length === 0) {
        this.status = "incomplet";
      }
    },

    calculStatus() {
      if (this.pieceSelected.etat === true) {
        this.status = "good";
        this.statusBadge = "Accepté";
      } else if (this.pieceSelected.fichier != null) {
        if (this.pieceSelected.fichier.length === 0) {
          this.status = "incomplet";
          this.statusBadge = "Incomplet";
        } else if (
          this.pieceSelected.fichier.slice().reverse()[0].etat === null
        ) {
          this.status = "wait";
          this.statusBadge = "En cours de traitement";
        } else if (
          this.pieceSelected.fichier.slice().reverse()[0].etat === false
        ) {
          this.status = "refus";
          this.statusBadge = "Refusé";
        } else {
          // Cas d'une pièce dont l'acceptation a été annulée : le dernier fichier
          // garde etat === true mais pieceSelected.etat n'est plus true.
          this.status = "incomplet";
          this.statusBadge = "Incomplet";
        }
      } else {
        if (this.pieceSelected.lastFichierEtat === null) {
          this.status = "incomplet";
          this.statusBadge = "Incomplet";
        } else if (this.pieceSelected.lastFichierEtat.etat === null) {
          this.status = "wait";
          this.statusBadge = "En cours de traitement";
        } else if (this.pieceSelected.lastFichierEtat.etat === false) {
          this.status = "refus";
          this.statusBadge = "Refusé";
        } else {
          this.status = "incomplet";
          this.statusBadge = "Incomplet";
        }
      }
    },
  },

  computed: {
    pieceClass() {
      return {
        "incomplet-border":
          this.status === "incomplet" || this.status === "incompletbis",
        "refuse-border": this.status === "refus",
        "waiting-border": this.status === "wait",
        "good-border": this.status === "good",
      };
    },

    iconClass() {
      return {
        "incomplet-light incomplet-dark":
          this.status === "incomplet" || this.status === "incompletbis",
        "refuse-light refuse-dark": this.status === "refus",
        "waiting-light waiting-dark": this.status === "wait",
        "good-light good-dark": this.status === "good",
      };
    },

    badgeClass() {
      return {
        "badge-incomplet":
          this.status === "incomplet" || this.status === "incompletbis",
        "badge-refuse": this.status === "refus",
        "badge-waiting": this.status === "wait",
        "badge-good": this.status === "good",
      };
    },
  },
};
</script>
<style scoped>
div.actions-wait {
  display: flex;
}

div.refus p.title-status-refus {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: black;
}

div.piece-justif {
  background-color: white;
  padding: 20px;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  min-width: 0;
}

div.piece-justif:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.07);
}

div.piece-justif div.header-piece {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}

div.piece-justif div.header-piece div.status-piece {
  display: flex;
  align-items: center;
  gap: 8px;
}

div.piece-justif div.header-piece .icon-container {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.incomplet-light {
  background-color: #fef3c7;
}

.incomplet-dark {
  color: #f59e0b;
}

.incomplet-border {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  border-top: 4px solid #f59e0b;
}

.refuse-light {
  background-color: #fff1f2;
}

.refuse-dark {
  color: #f43f5e;
}

.refuse-border {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  border-top: 4px solid #f43f5e;
}

.waiting-light {
  background-color: #eff6ff;
}

.waiting-dark {
  color: #3b82f6;
}

.waiting-border {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  border-top: 4px solid #3b82f6;
}

.good-light {
  background-color: #e8f7f1;
}

.good-dark {
  color: #1a9e6e;
}

.good-border {
  border: 1px solid #e8f7f1;
  border-radius: 16px;
  border-top: 4px solid #1a9e6e;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  white-space: nowrap;
}
.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.badge-incomplet {
  background: #fef3c7;
  color: #f59e0b;
}
.badge-incomplet .badge-dot {
  background: #f59e0b;
}

.badge-refuse {
  background: #fff1f2;
  color: #f43f5e;
}
.badge-refuse .badge-dot {
  background: #f43f5e;
}

.badge-waiting {
  background: #eff6ff;
  color: #3b82f6;
}
.badge-waiting .badge-dot {
  background: #3b82f6;
}

.badge-good {
  background: #e8f7f1;
  color: #1a9e6e;
}
.badge-good .badge-dot {
  background: #1a9e6e;
}

div.info-piece {
  margin-bottom: 1rem;
}

div.info-piece p.title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

div.info-piece p.desc {
  color: #64748b;
  font-size: 15px;
}

div.status-content div.add {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 3rem;
  width: 70px;
  height: 70px;
  font-size: 80px;
  color: white;
  background-color: #3b82f6;
  border: none;
  border-radius: 20px;
}

div.status-content div.add:hover {
  background-color: #f4f6f9;
  border: 1px solid #3b82f6;
  color: #3b82f6;
  box-shadow: 0 4px 12px #92bbfd;
}

input[type="file"] {
  opacity: 0;
  width: 0;
  height: 0;
}

div.status-content div.header-status {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}

p.title-status {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
}

p.sub-title-status {
  margin: 0;
  font-size: 15px;
  color: #64748b;
}

div.status-content div.header-status div.littleadd {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  font-size: 20px;
  color: white;
  background-color: #3b82f6;
  border: none;
  border-radius: 20px;
}

div.status-content div.header-status div.littleadd:hover {
  background-color: #f4f6f9;
  border: 1px solid #3b82f6;
  color: #3b82f6;
  box-shadow: 0 4px 12px #92bbfd;
}

div.status-content div.send-content p a:first-of-type {
  margin-left: 1rem;
  color: #0d6efd;
}

div.status-content div.send-content p a:first-of-type:hover {
  text-decoration: underline;
  cursor: pointer;
}

div.status-content div.send-content p &:last-of-type {
  color: black;
  cursor: pointer;
}

div.status-content div.send-content button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  width: 150px;
  font-size: 20px;
  color: white;
  background-color: #3b82f6;
  border: none;
  border-radius: 10px;
}

div.status-content div.send-content button:hover {
  background-color: #f4f6f9;
  border: 1px solid #3b82f6;
  color: #3b82f6;
  box-shadow: 0 4px 12px #92bbfd;
}

div.refus p.last {
  font-size: 14px;
  color: #f43f5e;
  font-weight: bold;
}

div.refus textarea {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

div.refus button.send-refus {
  border: none;
  background-color: #f43f5e;
  color: white;
  border-radius: 5px;
  margin-top: 2rem;
}

div.refus button.send-refus:hover {
  border: 1px solid #f43f5e;
  background-color: white;
  color: #f43f5e;
  border-radius: 5px;
}

div.refus button.send-refus:active {
  transform: translateY(-3px);
}

div.good-status {
  width: 70px;
  margin: auto;
}

div.refuse-accepted-row {
  display: flex;
  justify-content: center;
  margin-top: 0.75rem;
}

div.refuse-accepted-row button.btn-refuse-accepted {
  padding: 5px 14px;
  font-size: 11px;
  font-weight: 600;
  color: #f43f5e;
  background: #fff1f2;
  border: 1.5px solid #fca5a5;
  border-radius: 20px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  width: auto;
  line-height: 1.4;
}

div.refuse-accepted-row button.btn-refuse-accepted:hover {
  background: #f43f5e;
  color: #fff;
  border-color: #f43f5e;
}

div.valid-piece{
  width: 50px;
  margin: auto;
  margin-top: 1.5rem;
  cursor: pointer;
}

div.valid-piece:hover{
  width: 53px;
}

div.valid-piece.valid-piece-header{
  width: 22px;
  margin: 0;
  flex-shrink: 0;
}

div.valid-piece.valid-piece-header:hover{
  width: 24px;
}

p.file-error {
  color: #f43f5e;
  font-size: 13px;
  text-align: center;
  margin: 0.5rem 0;
}
</style>